import React, { useState } from 'react';
import { FiMusic, FiSettings, FiClock, FiShield, FiActivity } from 'react-icons/fi';
import MusicManagement from '../components/settings/MusicManagement';
import BusinessHoursManagement from '../components/settings/BusinessHoursManagement';
import AdminsManagement from '../components/settings/AdminsManagement';
import GeneralSettings from '../components/settings/GeneralSettings';
import AudioDiagnostics from '../components/settings/AudioDiagnostics';

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState('music');

  const tabs = [
    { id: 'music', label: "Musiqa va tovushlar", icon: FiMusic },
    { id: 'business-hours', label: "Ish vaqti", icon: FiClock },
    { id: 'audio', label: "Ovoz sifati", icon: FiActivity },
    { id: 'admins', label: "Adminlar", icon: FiShield },
    { id: 'general', label: "Umumiy sozlamalar", icon: FiSettings },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.pageTitle}>Sozlamalar</h1>
      </div>

      <div style={styles.tabsContainer}>
        {tabs.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              style={{
                ...styles.tab,
                ...(activeTab === tab.id ? styles.tabActive : {}),
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={16} />
              {tab.label}
            </button>
          );
        })}
      </div>

      <div style={styles.content}>
        {activeTab === 'music' && <MusicManagement />}
        {activeTab === 'business-hours' && <BusinessHoursManagement />}
        {activeTab === 'audio' && <AudioDiagnostics />}
        {activeTab === 'admins' && <AdminsManagement />}
        {activeTab === 'general' && <GeneralSettings />}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: '24px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    marginBottom: '24px',
  },
  pageTitle: {
    color: 'white',
    fontSize: '24px',
    margin: 0,
  },
  tabsContainer: {
    display: 'flex',
    gap: '8px',
    borderBottom: '1px solid #374151',
    marginBottom: '24px',
    flexWrap: 'wrap',
  },
  tab: {
    background: 'transparent',
    border: 'none',
    color: '#9ca3af',
    padding: '12px 16px',
    cursor: 'pointer',
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    borderBottom: '2px solid transparent',
    fontWeight: '500',
  },
  tabActive: {
    color: '#3b82f6',
    borderBottom: '2px solid #3b82f6',
  },
  content: {
    background: '#111827',
    borderRadius: '8px',
    padding: '20px',
  },
};
